import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useDevices } from "../../../../hooks/useDevices"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { DeviceGet } from "../../../models/Device"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Devices() {
  const { devicesList, isLoadingDevices } = useDevices()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/devices",
    },
    { field: "slaveId", headerName: "Slave ID" },
    { field: "familyName", headerName: "Family" },
  ]

  const sorted = [...devicesList].sort(
    (a, b) => Number(a.slaveId ?? 0) - Number(b.slaveId ?? 0)
  )

  const rows = sorted.map((device: DeviceGet) => ({
    id: device.id,
    name: device.name,
    slaveId: device.slaveId,
    familyName: device.family.name,
  }))

  const toolbar = useMemo(
    () => <DiMaAddButton url="/devices/create" feature={DimaFeatureShortNameEnum.DM} />,
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/devices/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDevices}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
